// test605
(605 && 0);
